import { AccordionBodyItem } from 'component/Accordion';
import { InputComponent } from 'component/Input';
import { RadioButton } from 'component/RadioButton';
import { React, useEffect, useState } from 'react';
import {
  CURRENT_FIELD_MARKING_LEGACY_OPTIONS,
  CURRENT_FIELD_MARKING_V2_OPTIONS,
} from 'consts/GeographicDescription';

export const FieldMarking = (props) => {
  const geographicDescription = props.formData.info.geographic_and_terrain_description;
  const isLegacy = props.formData?.info?._schema_version !== 2;
  const fieldMarkingOptions = isLegacy
    ? CURRENT_FIELD_MARKING_LEGACY_OPTIONS
    : CURRENT_FIELD_MARKING_V2_OPTIONS;
  const [otherCheckbox, setOtherCheckbox] = useState(false);

  useEffect(() => {
    setOtherCheckbox(isLegacy && geographicDescription.current_field_marking.includes('other'));
  }, [geographicDescription, isLegacy]);

  const handleGeographicDescription = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        geographic_and_terrain_description: {
          ...prevFormData.info.geographic_and_terrain_description,
          current_field_marking: value,
        },
      },
    }));
  };

  const handleOtherDescription = (value) => {
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData.info,
        geographic_and_terrain_description: {
          ...prevFormData.info.geographic_and_terrain_description,
          current_field_marking_other: value,
        },
      },
    }));
  };

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>6.5</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Поточне маркування на місцевості"
      titleEN="Current marking on the field"
      className={props.errors?.geographic_and_terrain_description?.current_field_marking ? 'error' : ''}
      rightContentClassName="w-60"
      children={(
        <>
          <div className="flex-group flex-wrap">
            {fieldMarkingOptions.map((option) => (
              <RadioButton
                key={option.value}
                id={
                  option.value === 'other' || option.value === 'none'
                    ? `current_field_marking_${option.value}`
                    : option.value
                }
                name="current_field_marking"
                value={option.value}
                label={option.label}
                checked={geographicDescription.current_field_marking.includes(option.value)}
                handleInput={(value) => {
                  setOtherCheckbox(value === 'other');
                  handleGeographicDescription(value);
                  if (value !== 'other') {
                    handleOtherDescription('');
                  }
                }}
                disable="false"
              />
            ))}
          </div>
          {otherCheckbox && (
            <InputComponent
              id="current_field_marking_other"
              style={{ width: 'calc(100% - 40px)' }}
              handleInput={handleOtherDescription}
              value={geographicDescription.current_field_marking_other || ''}
              blueLink
              limitChar
            />
          )}
        </>
      )}
    />
  );
};
